export default {"src":"/_next/static/media/winningsSecuredRays.0388c638.svg","height":231,"width":235,"blurWidth":0,"blurHeight":0};